import VKITAuth from '@beeline/lk-auth';
import { initAuth } from '@beeline/lk-utils';

import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

import {
  APP_API_URL,
  APP_AUTH_SERVER_URL,
  APP_API_URL_MOCK,
  APP_IDP_SERVER_URL,
  APP_IDP_CLIENT_ID,
} from ':constants';

export const auth = new VKITAuth({
  idpURL: APP_IDP_SERVER_URL,
  eauthURL: APP_AUTH_SERVER_URL,
  clientId: APP_IDP_CLIENT_ID,
  redirectURI: window.location.origin,
  disableDeprecatedWarning: true,
});

initAuth(auth);

export function login(): boolean {
  try {
    auth.startAuth();
    return true;
  } catch (err) {
    return false;
  }
}

export const API = axios.create({
  baseURL: APP_API_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

async function defaultRequestInterceptor(
  request: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> {
  const { headers, url } = request;

  if (url?.includes('/myprofile/') && APP_API_URL_MOCK) {
    request.baseURL = APP_API_URL_MOCK;
  }

  const accessToken = await auth.getAccessTokenAsync();
  const controller = new AbortController();

  if (!accessToken) {
    controller.abort();
  }

  headers.Authorization = `Bearer ${accessToken}`;

  return { ...request, signal: controller.signal };
}

export async function onRefreshRequired(
  error: AxiosError & { config: any },
): Promise<AxiosError | Error> {
  const { access_token_idp } = await auth.refreshTokens();

  if (error.config.headers) {
    error.config.headers.Authorization = `Bearer ${access_token_idp}`;
  }
  return axios.request(error.config ?? {});
}

async function errorRequestInterceptor(
  err: AxiosError & { config: any },
): Promise<undefined | AxiosError | Error> {
  if (err.response) {
    const { status } = err.response;
    const hasRefreshStatus = status === 401;
    if (hasRefreshStatus) {
      return onRefreshRequired(err);
    }
    return Promise.reject(err);
  }
  return err;
}

API.interceptors.request.use(defaultRequestInterceptor);
API.interceptors.response.use(undefined, errorRequestInterceptor);
